// extracted by mini-css-extract-plugin
export default {"breadContainer":"BreadCrumb_breadContainer__r05y8"};